// extracted by mini-css-extract-plugin
export var divider = "_fj-7";
export var itemsToggle = "_fj-8";
export var mergeModal = "_fj-1";
export var optionCard = "_fj-4";
export var radioGroup = "_fj-6";
export var radioOption = "_fj-0";
export var selected = "_fj-5";
export var shipmentOptions = "_fj-2";
export var tableOptions = "_fj-3";